import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class GuestAPI {
  getGuestsList(payload) {
    return api.post(API_URLS.URL.guests.getGuestsList, payload);
  }

  createGuest(payload) {
    return api.post(API_URLS.URL.guests.createGuest, payload);
  }
}
